import logo from '../../assets/img/logo.png';
import loadingGif from '../../assets/img/loading.gif';
import React, { useState } from "react";
import axios from "axios";
import { settings } from './../../Helpers/Settings.js';
import AuthService from '../../Auth/AuthService.js';
//import settings from './../../Settings.json';
import Swal from 'sweetalert2';
import * as CryptoJS from 'crypto-js';

export default function Login() {

    const [loading, setLoading] = useState(false);

    const [data, setData] = useState({
        username: "",
        password: "",
    });

    const handleChange = (e) => {
        const value = e.target.value;
        setData({...data, [e.target.name]: value,});
    };

    const handleSubmit = async (e) => {
        try {
            setLoading(true);

            e.preventDefault();

            let key = CryptoJS.enc.Utf8.parse("TedasBasinCimer*");
            let encryptedBytes = CryptoJS.AES.encrypt(data.password, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
            let encryptedString = encryptedBytes.toString();

            const userData = JSON.stringify({
                "mail": data.username,
                "password": encryptedString,
                "encrypted": true
            });

            console.log(userData);

            const res = await axios.post(settings.ApiUrl + "Login/Login", userData, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

            if (res.status === 200) {
                if (res.data.success === true) {
                    localStorage.setItem("ATGroupToken", res.data.value.token);
                    //axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.value.token}`;
                    //localStorage.setItem("refreshToken", response.data["refresh"]);

                    //await axios.get(settings.ApiUrl + "Mail/SendBildirimGunluk", { headers: AuthService.getHeaders() });

                    window.location.href = "/home";
                } else {
                    Swal.fire({ title: "Hata", text: res.data.message, icon: "error" });
                }
            } else {
                Swal.fire({ title: "Hata", text: "Bilinmeyen hata", icon: "error" });
            }
        } catch (error) {
            if (error.response) {
                Swal.fire({ title: "Hata", text: error.response.data.detail, icon: "error" });
            } else if (error.request) {
                Swal.fire({ title: "Hata", text: "network error", icon: "error" });
            } else {
                Swal.fire({ title: "Hata", text: error, icon: "error" });
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {
                loading ?
                    <div className="progressBackground">
                        <div className="progressPopup">
                            <img alt="Bekleyiniz..." src={loadingGif} />
                        </div>
                    </div>
                    :
                    ''
            }

            <div className="container" style={{marginLeft: '-300px!important'}}>

                <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                <div className="d-flex justify-content-center py-4">
                                    <a href="https://www.tedas.gov.tr" className="logo d-flex align-items-center w-auto">
                                        <img src={logo} alt="" ></img>
                                    </a>
                                </div>

                                <div className="card mb-3">

                                    <div className="card-body">

                                        <div className="pt-2 pb-2">
                                            <h5 className="card-title text-center pb-0 fs-4">Hoş geldiniz</h5>
                                            <p className="text-center">İşlem yapabilmek için lütfen giriş yapınız</p>
                                        </div>

                                        <div className="row g-3 needs-validation">

                                            <div className="col-12">
                                                <label htmlFor="tbUserName" className="form-label">E-Posta</label>
                                                <div className="input-group has-validation">
                                                    <span className="input-group-text" id="inputGroupPrepend"><i className="bi bi-person-fill"></i></span>
                                                    <input id="tbUserName" name="username" className="form-control" value={data.username} onChange={handleChange}
                                                        type="text" placeholder="E-posta adresiniz" autoComplete="off" required />
                                                    <div className="invalid-feedback">E-posta adresiniz giriniz.</div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <label htmlFor="tbPassword" className="form-label">Şifre</label>
                                                <div className="input-group has-validation">
                                                    <span className="input-group-text" id="inputGroupPrepend"><i className="bi bi-key-fill"></i></span>
                                                    <input id="tbPassword" name="password" value={data.password} onChange={handleChange} className="form-control"
                                                        type="password" placeholder="Şifreniz" autoComplete="off" required />
                                                    <div className="invalid-feedback">Şifrenizi giriniz.</div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <button type="submit" className="btn btn-primary btn-block w-100" onClick={handleSubmit}>Giriş</button>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div className="credits">
                                    <a href="/Auth/ForgetPassword" style={{fontWeight: '600'}}>Şifremi Unuttum</a>
                                </div>

                            </div>
                        </div>
                    </div>

                </section>

            </div>

        </div>
    );
}